import { Router, RouterConfiguration } from 'aurelia-router';

export class AirlinesIndexScreen {
  router: Router;

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      { route: '', redirect: 'list' },
      { route: 'list', moduleId: 'screens/administration/airlines-list', name: 'admin-airlines-list', title: 'Airlines' },
      { route: ['new', ':id'], moduleId: 'screens/administration/airline-detail', name: 'admin-airline-detail', activationStrategy: 'replace' }
    ]);

    this.router = router;
  }
}
